'use client';
import Typography from '@/components/shared/typography/typography.component';
import { useTranslation } from '@/hook';
import React from 'react';
import classes from './styles.module.scss';

type ClearAllTagVariant = 'red' | 'grey';
const ClearAllTag = ({
    tagClicked,
    variant = 'red',
}: {
    tagClicked: () => void;
    variant: ClearAllTagVariant;
}) => {
    const { t, IS_RTL } = useTranslation();
    const targetClass =
        variant === 'red' ? classes.containerred : classes.container;
    const targetClassText =
        variant === 'red' ? classes.containerred__text : classes.containe__text;

    return (
        <div onClick={() => tagClicked()} className={targetClass}>
            <Typography
                variant={'body2Medium'}
                style={
                    IS_RTL
                        ? { marginLeft: '4px', width: 'max-content' }
                        : { marginRight: '4px', width: 'max-content' }
                }
                className={targetClassText}
            >
                {t('Clear')}
            </Typography>
        </div>
    );
};

export default ClearAllTag;
